export default __webpack_public_path__ + "static/media/rank-icon.d634e14d.svg";